import React, { useEffect, useState, useContext } from "react";
import {
  Box,
  TextField,
  Button,
  FormGroup,
  FormControl,
  Alert,
  AlertTitle,
  Stack,
  Container,
  Backdrop,
  CircularProgress,
  InputLabel,
  IconButton,
  Typography,
  Grid,
  Paper,
} from "@material-ui/core";
import axios from "axios";
import { Link } from "react-router-dom";
import { CartContext } from '../CartContext/CartContext';
import Cookies from "universal-cookie";
import HomePage2 from "../HomePage2/HomePage2";
import { config, setAuthCookie } from "../../config/config";
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import InputAdornment from '@material-ui/core/InputAdornment';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import StorefrontIcon from '@material-ui/icons/Storefront';
import BusinessIcon from '@material-ui/icons/Business';
import BuildIcon from '@material-ui/icons/Build';
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';

// Las cuentas rápidas pertenecen únicamente al entorno de demostración. Se
// habilitan de forma explícita para evitar que un build de Almafer exponga
// credenciales de ejemplo en la pantalla de acceso.
const showDemoAccess = process.env.NODE_ENV !== "production"
  && process.env.REACT_APP_SHOW_DEMO_ACCESS === "true";
const portalTitle = config.COMPANY_NAME
  ? `Catálogo y pedidos ${config.COMPANY_NAME}`
  : "Catálogo y pedidos";

const cookies = new Cookies();

export default function Login() {
  const cartContext = useContext(CartContext);
  const { setUser } = cartContext;
  const sessionExpired = new URLSearchParams(window.location.search).get('reason') === 'session-expired'
    || window.sessionStorage.getItem('almafer.sessionExpired') === 'true';
  const registrationPending = new URLSearchParams(window.location.search).get('registered') === 'pending';

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loginIssue, setLoginIssue] = useState(() => {
    if (sessionExpired) {
      return {
        severity: 'warning',
        title: 'Tu sesión venció',
        message: 'Ingresá nuevamente para continuar desde tu cuenta.',
      };
    }
    if (registrationPending) {
      return {
        severity: 'success',
        title: 'Registro recibido',
        message: 'Tu cuenta quedó pendiente de aprobación. Podrás ingresar cuando un administrador la habilite.',
      };
    }
    return null;
  });
  const [open, setOpen] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event) => event.preventDefault();
  const token = cookies.get("token");

  useEffect(() => {
    if (sessionExpired) {
      window.sessionStorage.removeItem('almafer.sessionExpired');
    }
  }, [sessionExpired]);

  const performLogin = (targetEmail, targetPassword) => {
    setLoginIssue(null);
    setOpen(true);
    const configuration = {
      method: "post",
      url: `${config.SERVER}/login`,
      data: {
        email: targetEmail,
        password: targetPassword,
      },
    };

    axios(configuration)
      .then((result) => {
        setAuthCookie(cookies, "token", result.data.token);
        setAuthCookie(cookies, "user", result.data.email);
        setAuthCookie(cookies, "IdVendedor", result.data.IdVendedor);
        setUser(result.data.email);
        setOpen(false);
        window.location.href = "/";
      })
      .catch((error) => {
        const code = error.response?.data?.code;
        setLoginIssue(code === 'ACCOUNT_PENDING'
          ? {
              severity: 'warning',
              title: 'Cuenta pendiente de aprobación',
              message: 'Recibimos tu registro. Podrás ingresar cuando un administrador habilite la cuenta.',
            }
          : {
              severity: 'error',
              title: 'No pudimos iniciar sesión',
              message: error.response?.data?.message || 'Revisá el correo y la contraseña e intentá nuevamente.',
            });
        setOpen(false);
      });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    performLogin(email, password);
  };

  const handleQuickLogin = (demoEmail, demoPassword) => {
    setEmail(demoEmail);
    setPassword(demoPassword);
    performLogin(demoEmail, demoPassword);
  };

  return (
    <>
      {token ? (
        <HomePage2 />
      ) : (
        <Container maxWidth="sm" style={{ marginTop: "20px", marginBottom: "40px" }}>
          <Typography variant="h4" align="center" gutterBottom style={{ fontWeight: 700, color: "#082b66" }}>
            {portalTitle}
          </Typography>
          <Typography variant="body2" align="center" color="textSecondary" style={{ marginBottom: "20px" }}>
            Ingresá a tu cuenta para consultar tus precios y realizar pedidos.
          </Typography>

          {/* Selector de Cuentas de Demostración (sólo demo local) */}
          {showDemoAccess && (
            <Paper elevation={3} style={{ padding: "18px", marginBottom: "24px", backgroundColor: "#f8fafd", border: "1px solid #bbdefb", borderRadius: "12px" }}>
            <Typography variant="subtitle2" style={{ fontWeight: "bold", color: "#082b66", marginBottom: "12px", textAlign: "center" }}>
              🎯 Probar Demo en Vivo (Acceso con 1 Clic):
            </Typography>
            <Grid container spacing={1.5}>
              <Grid item xs={12} sm={6}>
                <Button
                  variant="outlined"
                  fullWidth
                  startIcon={<BusinessIcon style={{ color: "#082b66" }} />}
                  style={{ textTransform: "none", borderColor: "#9aa9bd", justifyContent: "flex-start", padding: "8px 12px" }}
                  onClick={() => handleQuickLogin("mayorista1@demo.com", "demo123")}
                >
                  <Box textAlign="left">
                    <Typography variant="body2" style={{ fontWeight: 600, fontSize: "0.82rem" }}>Mayorista Platino</Typography>
                    <Typography variant="caption" style={{ color: "#2e7d32", fontWeight: 700 }}>Descuento 20%</Typography>
                  </Box>
                </Button>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Button
                  variant="outlined"
                  fullWidth
                  startIcon={<StorefrontIcon style={{ color: "#0288d1" }} />}
                  style={{ textTransform: "none", borderColor: "#9aa9bd", justifyContent: "flex-start", padding: "8px 12px" }}
                  onClick={() => handleQuickLogin("mayorista2@demo.com", "demo123")}
                >
                  <Box textAlign="left">
                    <Typography variant="body2" style={{ fontWeight: 600, fontSize: "0.82rem" }}>Distribuidor Litoral</Typography>
                    <Typography variant="caption" style={{ color: "#082b66", fontWeight: 700 }}>Descuento 15%</Typography>
                  </Box>
                </Button>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Button
                  variant="outlined"
                  fullWidth
                  startIcon={<BuildIcon style={{ color: "#e65100" }} />}
                  style={{ textTransform: "none", borderColor: "#9aa9bd", justifyContent: "flex-start", padding: "8px 12px" }}
                  onClick={() => handleQuickLogin("gremio@demo.com", "demo123")}
                >
                  <Box textAlign="left">
                    <Typography variant="body2" style={{ fontWeight: 600, fontSize: "0.82rem" }}>Cliente Gremio / Taller</Typography>
                    <Typography variant="caption" style={{ color: "#e65100", fontWeight: 700 }}>Descuento 10%</Typography>
                  </Box>
                </Button>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Button
                  variant="outlined"
                  fullWidth
                  startIcon={<SupervisorAccountIcon style={{ color: "#6a1b9a" }} />}
                  style={{ textTransform: "none", borderColor: "#ce93d8", justifyContent: "flex-start", padding: "8px 12px" }}
                  onClick={() => handleQuickLogin("admin@demo.com", "demo123")}
                >
                  <Box textAlign="left">
                    <Typography variant="body2" style={{ fontWeight: 600, fontSize: "0.82rem" }}>Administrador</Typography>
                    <Typography variant="caption" style={{ color: "#6a1b9a", fontWeight: 700 }}>Panel de Control</Typography>
                  </Box>
                </Button>
              </Grid>
            </Grid>
            </Paper>
          )}

          {/* Formulario tradicional */}
          <Paper elevation={1} style={{ padding: "24px", borderRadius: "12px" }}>
            <form onSubmit={handleSubmit}>
              <FormGroup>
                <FormControl fullWidth style={{ marginBottom: "16px" }}>
                  <TextField
                    id="login-email"
                    label="Correo Electrónico"
                    name="email"
                    type="email"
                    autoComplete="email"
                    variant="outlined"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </FormControl>
              </FormGroup>

              <FormGroup>
                <FormControl variant="outlined" fullWidth style={{ marginBottom: "20px" }}>
                  <InputLabel htmlFor="outlined-adornment-password">Contraseña</InputLabel>
                  <OutlinedInput
                    id="outlined-adornment-password"
                    type={showPassword ? 'text' : 'password'}
                    autoComplete="current-password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label={showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'}
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                          edge="end"
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    }
                    label="Contraseña"
                    required
                  />
                </FormControl>
              </FormGroup>

              <Button
                variant="contained"
                color="primary"
                size="large"
                fullWidth
                type="submit"
                style={{ padding: "10px", fontWeight: "bold", borderRadius: "8px" }}
              >
                Ingresar al Catálogo
              </Button>

              <Stack style={{ width: "100%", marginTop: "16px" }} spacing={2}>
                {loginIssue && (
                  <Alert severity={loginIssue.severity}>
                    <AlertTitle>{loginIssue.title}</AlertTitle>
                    {loginIssue.message}
                  </Alert>
                )}
              </Stack>

              <Box textAlign="center" style={{ marginTop: "18px" }}>
                <Typography variant="body2" color="textSecondary">
                  ¿Todavía no tenés una cuenta?
                </Typography>
                <Button
                  component={Link}
                  to="/register"
                  type="button"
                  color="primary"
                  style={{ textTransform: "none", fontWeight: 700 }}
                >
                  Registrate
                </Button>
              </Box>
            </form>
          </Paper>
        </Container>
      )}
      <Backdrop
        style={{ color: '#fff', zIndex: 9999 }}
        open={open}
        aria-label="Iniciando sesión"
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
}
